import { createSvgIcon } from "@mui/material/utils";

// Mobildeki MaterialCommunityIcons simgelerinin aynısı (MDI yolları), MUI
// simgeleri gibi sx ve fontSize alır.

/** Hatim: MDI "book-open-page-variant". */
export const HatimIcon = createSvgIcon(
  <path d="M19 2L14 6.5V17.5L19 13V2M6.5 5C4.55 5 2.45 5.4 1 6.5V21.16C1 21.41 1.25 21.66 1.5 21.66C1.6 21.66 1.65 21.59 1.75 21.59C3.1 20.94 5.05 20.5 6.5 20.5C8.45 20.5 10.55 20.9 12 22C13.35 21.15 15.8 20.5 17.5 20.5C19.15 20.5 20.85 20.81 22.25 21.56C22.35 21.61 22.4 21.59 22.5 21.59C22.75 21.59 23 21.34 23 21.09V6.5C22.4 6.05 21.75 5.75 21 5.5V19C19.9 18.65 18.7 18.5 17.5 18.5C15.8 18.5 13.35 19.15 12 20V6.5C10.55 5.4 8.45 5 6.5 5Z" />,
  "Hatim"
);

/** Müzakere: MDI "forum-outline". */
export const MuzakereIcon = createSvgIcon(
  <path d="M15 4V11H5.17L4 12.17V4H15M16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2M21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z" />,
  "Muzakere"
);

/** Katılınan müzakere: MDI "forum" (dolu). */
export const MuzakereDoneIcon = createSvgIcon(
  <path d="M17 12V3C17 2.45 16.55 2 16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12M21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z" />,
  "MuzakereDone"
);
